import UserMenuButton from "@/features/user-menu/UserMenuButton"

export default function TopBar() {
  return (
    <header className="border-ring-foreground/20 sticky top-0 z-10 flex h-10 flex-row items-center justify-end border-b bg-background px-2">
      <UserMenuButton />
    </header>
  )
}
